import Button from '@shared/components/core/button/CoreButton';
import { ICoreButtonProps } from '@shared/models/components/ICoreButtonProps';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CreateDeviceTypeDialog from './CreateDeviceTypeDialog';

interface ICreateDeviceTypeAccessProps extends Omit<ICoreButtonProps, 'onClick' | 'children'> {
    children?: never;
    onClick?: never;
    href?: never;
}

export default function CreateDeviceTypeAccess({
    $color = 'accent',
    $size = 'small',
    startIcon = 'plusLight',
    ...restProps
}: ICreateDeviceTypeAccessProps) {
    const { t } = useTranslation();
    const [openDialog, setOpenDialog] = useState<boolean>(false);
    const handleOpenDialog = () => setOpenDialog(true);
    const handleCloseDialog = () => setOpenDialog(false);

    return (
        <>
            <Button $color={$color} $size={$size} onClick={handleOpenDialog} startIcon={startIcon} {...restProps}>
                {t('common:organization.projects.deviceType.action')}
            </Button>
            <CreateDeviceTypeDialog open={openDialog} onClose={handleCloseDialog} />
        </>
    );
}
